import React, { useRef, useState } from 'react'
import "./ProfilePicture.scss"
import { useToast } from '../../hooks/useToast';
import Icon from '../Icon/Icon';
import FullScreenImage from '../MediaPlayer/FullScreenImage';

const DefaultAvatar = () => (
    <Icon alias="profile-picture" />
);

const ProfilePicture = ({ imgUrl, onImageUpload, classNames, width = 80, height = 80, showIcon = false, no_edit = false, handleClick, zoomEnable = false }) => {
    const fileInputRef = useRef(null);
    const toast = useToast()
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                toast("File is too large. Maximum size is 5MB.", "danger")
            }
            try {
                const formData = new FormData()
                formData.append("profile_picture", file)
                onImageUpload(formData)
            } catch (e) {
                console.log(e)
                toast("Failed to process the selected file.")
            }
        }
    };

    return (
        <div className={`pic-container ${classNames}`} onClick={() => !no_edit ? fileInputRef.current.click() : handleClick() ? handleClick() : {}} style={{ width, height, borderRadius: width / 2 }}>
            {imgUrl ? <img src={imgUrl} alt="Profile" style={{ borderRadius: width / 2 }}

                onClick={() => setIsModalOpen(true)}

            /> : <DefaultAvatar />}
            {showIcon && !no_edit && (
                <div className="camera-container">
                    <Icon alias="camera-icon" className="icon-camera" />
                </div>
            )}
            {isModalOpen && zoomEnable && <FullScreenImage imgUrl={imgUrl} isModalOpen={isModalOpen} onClick={() => setIsModalOpen(false)} />}
            {!no_edit && <input
                ref={fileInputRef} // Attach the ref to input
                type="file"
                accept="image/png,image/jpg"
                className="file-input"
                onChange={handleFileChange}
                aria-label="Upload profile picture"
            />}
        </div>
    )
}

export default ProfilePicture